import { useState } from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { categories } from '@/mocks/tvSeries';

export default function CategoryNav() {
  const { t } = useTranslation();
  const [activeCat, setActiveCat] = useState('all');

  return (
    <section className="bg-background-50 py-8">
      <div className="max-w-[1440px] mx-auto px-4 md:px-6">
        <div className="flex items-center justify-between mb-5">
          <h2 className="text-lg md:text-xl font-bold text-foreground-900">
            <i className="ri-grid-line mr-2 text-primary-500"></i>
            {t('home:allCategories')}
          </h2>
          <Link to="/category/dianshiju" className="text-sm text-primary-500 hover:text-primary-600 font-medium cursor-pointer">
            {t('home:viewAll')} <i className="ri-arrow-right-line ml-1"></i>
          </Link>
        </div>
        <div className="flex items-center gap-2 overflow-x-auto pb-2">
          <button
            onClick={() => setActiveCat('all')}
            className={`whitespace-nowrap px-4 py-2 text-sm font-medium rounded-full transition-all cursor-pointer ${
              activeCat === 'all'
                ? 'bg-primary-500 text-white'
                : 'bg-background-100 text-foreground-600 hover:bg-background-200'
            }`}
          >
            {t('all')}
          </button>
          {categories.map((cat) => (
            <Link
              key={cat.slug}
              to={`/category/${cat.slug}`}
              onClick={() => setActiveCat(cat.slug)}
              className={`whitespace-nowrap px-4 py-2 text-sm font-medium rounded-full transition-all cursor-pointer flex items-center gap-1.5 ${
                activeCat === cat.slug
                  ? 'bg-primary-500 text-white'
                  : 'bg-background-100 text-foreground-600 hover:bg-background-200'
              }`}
            >
              <i className={`${cat.icon} text-sm`}></i>
              {cat.name}
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}